import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, ListChecks } from "lucide-react";

export function ReconciliationHeader() {
  const navigate = useNavigate();

  return (
    <div className="flex items-start justify-between gap-4">
      <div className="space-y-1">
        <h1 className="text-lg font-bold">Reconciliation</h1>
        <p className="text-muted-foreground">
          Simple daily view: money in/out, paid expenses, expected vs real bank balance, and the gap.
        </p>
      </div>

      <div className="flex gap-2">
        <Button variant="outline" onClick={() => navigate("/finance/banking/transactions")}>
          <ListChecks className="h-4 w-4 mr-2" />
          Transactions
        </Button>
        <Button onClick={() => navigate("/finance/banking/transactions")}>
          <ArrowRight className="h-4 w-4 mr-2" />
          Import / Review
        </Button>
      </div>
    </div>
  );
}